import {Injectable} from "@angular/core";
import {MessageService} from "primeng/api";

@Injectable({providedIn: "root"})
export class MessageToastService {

  constructor(private messageService: MessageService) {
  }

  success(message: string) {
    if(message) this.messageService.add({severity: 'success', summary: 'Sucesso', detail: message, life: 5000})
  }

  error(message: string) {
    if(message) this.messageService.add({severity: 'error', summary: 'Erro', detail: message, life: 5000})
  }

}
